import * as actionTypes from './actionTypes';
import axios from 'axios';

let prod = false;

export const setHotels = (hotelsData) => {
    return {
        type: actionTypes.SET_HOTELS,
        hotelsData: hotelsData
    }
}

export const setHotelDetails = (detailsData) => {
    return {
        type: actionTypes.SET_HOTEL_DETAILS,
        detailsData: detailsData
    }
}

export const setSelectedAmenity = (selectedAmenity) => {
    return {
        type: actionTypes.SET_SELECTED_AMENITY,
        selectedAmenity: selectedAmenity
    }
}

export const setHotelReviewDetails = (reviewData, rooms) => {
    return {
        type: actionTypes.SET_HOTEL_REVIEW_DETAILS,
        reviewData: reviewData,
        rooms: rooms
    }
}

export const setUpdateMarkup = (markupData) => {
    return {
        type: actionTypes.SET_UPDATE_MARKUP,
        markupData: markupData
    }
}

export const getHotels = (hotelSearchParams, isNew) => {
    return dispatch => {
        let url = 'http://localhost:3000/hotels/getHotels';
        if (prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/hotels/getHotels';
        }
        if(isNew) {
            dispatch(setRevisedDataLoading());
        } else {
            dispatch(setLoading());
        }
        axios.get(url + hotelSearchParams, { headers: {'ssoToken': localStorage.getItem('ssoToken')} })
                .then(response => {
                    const hotelsData = response.data.data;
                    dispatch(setHotels(hotelsData));
                })
                .catch(error => {
                    dispatch(getHotelsFailed(error))
                })
    }
}

export const setLoading = () => {
    return {
        type: actionTypes.SET_LOADING
    }
};

export const setRevisedDataLoading = () => {
    return {
        type: actionTypes.SET_REVISED_DATA_LOADING
    }
}

export const setDetailLoading = () => {
    return {
        type: actionTypes.SET_DETAIL_LOADING
    }
}

export const getHotelsFailed = () => {
    return {
        type: actionTypes.GET_HOTELS_FAILED
    }
}

export const getHotelDetails = (hotelDetailParams) => {
    return dispatch => {
        let url = 'http://localhost:3000/hotels/getHotelDetails';
        if (prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/hotels/getHotelDetails';
        }
        dispatch(setDetailLoading());
        axios.get(url + hotelDetailParams)
        .then(response => {
            const detailsData = response.data.data;
            dispatch(setHotelDetails(detailsData));
        })
        .catch(err => {
            console.log(err);
        });
    }
}

export const setReviewLoading = () => {
    return {
        type: actionTypes.SET_REVIEW_LOADING
    }
}

export const getHotelReviewDetails = (reviewParams) => {
    const params = new URLSearchParams(reviewParams);

    return dispatch => {
        let url = 'http://localhost:3000/hotels/getHotelReviewDetails';
        if (prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/hotels/getHotelReviewDetails';
        }
        dispatch(setReviewLoading());
        axios.get(url + reviewParams).then(response => {
            const reviewData = response.data.data;
            const rooms = params.get("rooms");
            dispatch(setHotelReviewDetails(reviewData, rooms));
        });
    }
}

export const addHotelPax = (honorific, firstName, lastName, isSelected) => {
    return {
        type: actionTypes.ADD_HOTEL_PAX,
        title: honorific,
        firstName: firstName,
        lastName: lastName,
        isSelected: isSelected
    }
}

export const toggleHotelPax = (id) => {
    return {
        type: actionTypes.TOGGLE_HOTEL_PAX,
        id: id
    }
}

export const editHotelPax = (id) => {
    return {
        type: actionTypes.EDIT_HOTEL_PAX,
        id: id
    }
}

export const updateMarkup = (markupParams) => {
    return dispatch => {
        let url = 'http://localhost:3000/hotels/updateMarkup?';
        if (prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/hotels/updateMarkup?';
        }
        axios.get(url + markupParams)
        .then(response => {
            console.log(response);
            const markupData = response.data.data;
            dispatch(setUpdateMarkup(markupData));
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/hotels.js